import React from 'react';
import styles from './loader.module.css';

const Loader = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.loader}>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
